// GET 
export const getIndConditionApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/induction_conditions${queryString ? `?${queryString}` : ""}`;
};
// POST 
export const addIndConditionAPi = (params) => {
    return `lease/${params?.leaseSlug}/induction_conditions`;
};
// PUT 
export const updateIndConditionAPi = (params) => {
    return `lease/${params?.leaseSlug}/induction_conditions/${params?.slug}`;
};
// DELETE 
export const deleteIndConditionApi = (params) => {
    return `lease/${params?.leaseSlug}/induction_conditions`;
};
// Post Attachment 
export const indConditionfileUploadApi = (slug) => {
    return `lease/induction_conditions/${slug}/attachments`;
};
// Reserve account  api
export const clauseAPi = (params) => {
    return `/condition_clause?lite=true`;
};
export const inductionConditionsfileUploadPostApi = (induction_conditions_slug) => {
    return `/get-pre-signed-url/induction_conditions/${induction_conditions_slug}`;
};

export const inductionConditionsAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/induction_conditions/${attachments_slug}`
}

